import { FormInstance } from 'antd';
import { FieldDataRecord } from '../components/subjectBlocks/previewPDFComponents/PreviewNestedData';

export const fieldIsRequiredText = 'Laukas privalomas';
export const inputToLongText = 'Viršytas leistinas simbolių kiekis';

export const fieldIsRequired = {
  required: true,
  message: fieldIsRequiredText,
};

export type CompWithFormProp = {
  form: FormInstance;
};

export type FormStempContentProps = CompWithFormProp & {
  currentStep: number;
};

export const hideFormStepContent: React.CSSProperties = {
  display: 'none',
};

export const shoolYearList = [
  '2025 / 2026 m.m.',
  '2026 / 2027 m.m.',
  '2027 / 2028 m.m.',
  '2028 / 2029 m.m.',
  '2029 / 2030 m.m.',
];

export const periodsList = [
  'I pusmetis',
  'II pusmetis',
  '1 trimestras',
  '2 trimestras',
  '3 trimestras',
  'metams',
];

export type FormConfigProps = {
  label: string;
  value: string;
  isInput?: boolean;
  paddingLeft?: number;
  children?: Record<string, FormConfigProps>;
};

export type FormDataArgs = {
  registration: Record<string, string>;
  subject: Record<string, FieldDataRecord>;
};

type MetaDataArgs = {
  version: string;
  creationDate: string;
};

export type JsonFormDataArgs = {
  formData: FormDataArgs;
  metaData: MetaDataArgs;
};

export const formInitialValues = {
  registration: {
    schoolYear: shoolYearList[0],
  },
};

export type CompWithStepsProps = {
  form: FormInstance;
  currentStep: number;
  setCurrentStep: (step: number) => void;
};

export const contentStyling = {
  paddingLeft: 48,
};
